// This file is used to suppress React Router warnings until we can properly enable v7 features
const originalWarn = console.warn;
console.warn = (...args) => {
  // Only suppress the v7_startTransition warning since we can't enable it yet
  if (
    typeof args[0] === 'string' &&
    args[0].includes('v7_startTransition')
  ) {
    return;
  }
  originalWarn.apply(console, args);
}; 